module.exports = __webpack_public_path__ + "bg-c.85ed17d591100cfe1f65.jpg";


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/assets/image/bg-c.jpg
// module id = ../../../../../src/assets/image/bg-c.jpg
// module chunks = main